<template>
    <div class="PropertyUploadImg">
        <Box title="资产图片上传">
            <FacilityDetails :data="{
            Images:require('@/assets/img/Icon_1.png'),
            EquName: data.EquName,
            EquNo: data.EquCode,
            Size: data.EquType,
            EquNumber: data.EquNumber,
            DepartmentName: data.DepartmentName,
            deadline: data.deadline
        }" :hidden-department="true" />
            <div class="tabsItems">
                <van-tabs @click="propconfirm" type="line" background="#ffffff" color="#ffffff" v-model="activeName"
                    sticky swipeable>
                    <van-tab v-for="(item,key) in popupArray" :key="key" :title="item.name" :name="item.id">
                    </van-tab>
                </van-tabs>
            </div>

            <div class="ImgItems">
                <ImgModule :disabled="!$UserInfo.RYLB==='2'" upload v-if="uploadImg" name="DABH"
                    :deletable="$UserInfo.RYLB==='2'?true:false" @afterRead="afterRead(arguments[0])"
                    @deleteImg="deleteImg(arguments[0])" :img="uploadImg" />
            </div>

        </Box>
        <!-- <Footer button="完成" @change="upload"/> -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        Tab,
        Tabs
    } from 'vant';
    import Box from '../../components/commonBox/commonBox'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import Footer from '../../components/footer/footer'
    import Field from '../../components/field/field'
    import Bus from "../../components/bus/bus";
    import ImgModule from '../../components/imgModule/imgModule'
    Vue.use(Tab);
    Vue.use(Tabs);
    export default {
        name: 'PropertyUploadImg',
        data() {
            return {
                active: 0,
                activeName: 4,
                data: this.$route.params.item,
                uploadImg: [], //  图片
                type: null, //  档案类型,
                selectIndex: 0,
                ImgArray: [], //当图片原始集合
                popupArray: [{
                        id: 4,
                        name: '申购审批表'
                    }, {
                        id: 9,
                        name: '合同信息'
                    }, {
                        id: 0,
                        name: '安装验收'
                    }, {
                        id: 1,
                        name: '技术支持'
                    },
                    {
                        id: 2,
                        name: '购置档案'
                    }, {
                        id: 8,
                        name: '质量检测'
                    }, {
                        id: 6,
                        name: '预防性维护'
                    }, {
                        id: 7,
                        name: '安全检查'
                    }, {
                        id: 5,
                        name: '报废审批表'
                    },
                    {
                        id: 10,
                        name: '合格证'
                    }, {
                        id: 11,
                        name: '发票'
                    }, {
                        id: 12,
                        name: '资产图片'
                    }
                ],
                popup: ['申购审批表', '合同信息', '安装验收', '技术支持', '购置档案', '质量检测', '预防维护', '安全检查', '报废审批表', '合格证', '发票', '资产图片'],
            }
        },
        components: {
            Box,
            FacilityDetails,
            Footer,
            Field,
            ImgModule,
        },
        mounted() {
            this.propconfirm();
        },
        methods: {
            // upload() {
            //     this.type = null
            //     this.uploadImg = []
            // },
            propconfirm() {
                this.uploadImg.splice(0, this.uploadImg.length);
                this.$post('api/Repair/GetTPListByDALX', {
                    SBBH: this.data.EquCode,
                    DALX: this.activeName,
                    Sotre: this.$UserInfo.StoreCode,
                    isDownload: false
                }, {
                    timeout: 100000
                }).then(result => {
                    this.ImgArray = result.TPList;
                    let uploadImg = [];
                    for (let i = 0; i < result.TPList.length; i++) {
                        uploadImg.push({
                            DABH: result.TPList[i].DABH,
                            url: result.TPList[i].RePath
                        });
                    }
                    this.$Bus.$emit('YSRKDelete', uploadImg);
                })
            },
            afterRead(value) { //图片上传
                let params = {};
                // let imgSize = value.file.size / 1024 / 1024;
                // console.log(this.ImgArray);
                // if (imgSize > 5.0) {
                //     this.$Toast({
                //         message: '上传图片不得大于5.0MB，请压缩后重试!',
                //         duration: 2000,
                //     });
                // } else {
                value instanceof Array ? params = {
                    base64Str1: 1 <= value.length ? value[0].content : '',
                    base64Str2: 2 <= value.length ? value[1].content : '',
                    base64Str3: 3 <= value.length ? value[2].content : '',
                    base64Str4: 4 <= value.length ? value[3].content : '',
                    base64Str5: 5 <= value.length ? value[4].content : '',
                    base64Str6: 6 <= value.length ? value[5].content : '',
                    base64Str7: 7 <= value.length ? value[6].content : '',
                    base64Str8: 8 <= value.length ? value[7].content : '',
                    base64Str9: 9 <= value.length ? value[8].content : '',
                    base64Str10: 10 <= value.length ? value[9].content : '',
                    EquId: this.data.EquCode,
                    DocType: this.activeName,
                    UserId: this.$UserInfo.UserId
                } : params = {
                    base64Str1: value.content,
                    EquId: this.data.EquCode,
                    DocType: this.activeName,
                    UserId: this.$UserInfo.UserId
                };
                this.$post('api/Repair/UploadDoc', params, {
                    timeout: 100000
                }).then(result => {
                    if (result.Status) {
                        this.$Toast('上传成功!', 1);
                        setTimeout(x => {
                            this.propconfirm(); //重新加载图片集
                        }, 500);
                    }
                });
                // }
            },
            deleteImg(value) { //图片删除
                const data = this.ImgArray.find(x => x.DABH === value.DABH);
                if (data) {
                    this.$Dialog.confirm({
                        message: '确定删除?'
                    }).then(() => {
                        this.$post('api/Repair/DelZCTP', {
                            DABH: value.DABH,
                            SBBH: this.data.EquCode,
                            DAMC: data.DAMC,
                            RePath: data.DALJ
                        }).then(result => {
                            if (result.Status) {
                                this.$Toast('删除成功!', 1);
                                setTimeout(x => {
                                    this.propconfirm(); //重新加载图片集
                                }, 500);
                            } else this.$Toast('删除失败!');
                        })
                    }).catch(() => {
                        //取消删除!
                    });
                } else this.$Toast('数据异常，请联系管理员!');
            }
        },
        watch: {
            $route(to, from) {
                if (from.name === 'PropertyRecord') {
                    this.type = null
                    this.uploadImg = null
                    this.data = this.$route.params.item ? this.$route.params.item : {}
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .imgModuleBox {
        margin-top: 100px !important;
    }
</style>



// WEBPACK FOOTER //
// src/page/propertyUploadImg/propertyUploadImg.vue